import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders, getHeadersForCsv } from "../../utils/AuthorizationUtil";
import {
  BASE_PRICING_URL,
  BASE_URL,
  REPORTING_BASE_URL,
} from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";
import { TRANSLATION_TOOL_REGIONS } from "../../common/Constants";

export default class POReportingClient {
  static baseUrl = BASE_URL;

  static pricingUrl = BASE_PRICING_URL;
  static reportingUrl = REPORTING_BASE_URL;

  static getAllTheMarkets(token) {
    const url = `${this.baseUrl}/po/marketIds`;
    return axios
      .get(url, getHeaders(token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadNSCActivationReportInCsv(token) {
    const url = `${this.baseUrl}/po/regional-NSC-report`;
    const universalBOM = "\uFEFF";
    return axios
      .get(url, getHeadersForCsv(token))
      .then((response) => encodeURIComponent(`${universalBOM}${response.data}`))
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadCrossDealerActivationReportInCsv(token) {
    const url = `${this.baseUrl}/po/regional-Dealer-report`;
    const universalBOM = "\uFEFF";
    return axios
      .get(url, getHeadersForCsv(token))
      .then((response) => encodeURIComponent(`${universalBOM}${response.data}`))
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadCrossDealerPricingReportInCsv(token) {
    const url = `${this.pricingUrl}/po/pricing-report`;
    const universalBOM = "\uFEFF";
    return axios
      .get(url, getHeadersForCsv(token))
      .then((response) => encodeURIComponent(`${universalBOM}${response.data}`))
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadDailyHourlyOrderReport(user, filterData) {
    let url = `${this.baseUrl}/reports/reservation-summary-report?market=${user.market}`;
    if (filterData !== undefined && filterData !== null)
      url = url + `&filterData=${filterData}`;

    const universalBOM = "\uFEFF";
    return axios
      .get(url, getHeadersForCsv(user.token))
      .then((response) => encodeURIComponent(`${universalBOM}${response.data}`))
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadDailyHourlyOrderReportXlsx(user, filterData) {
    const requestBody = {
      userType: user.userType,
      marketId: user.market,
      filterData: filterData,
    };

    const url = `${this.reportingUrl}/reporting/${user.market}/eu-reservations-report`;

    return axios
      .post(url, requestBody, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }

  static downloadNSCLeadTimesReportInCsv(token) {
    const url = `${this.baseUrl}/po/NSC-lead-times-report`;
    const universalBOM = "\uFEFF";
    return axios
      .get(url, getHeadersForCsv(token))
      .then((response) => encodeURIComponent(`${universalBOM}${response.data}`))
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadDealerDeliveryRangesInCsv(user) {
    const url = `${this.baseUrl}/po/delivery-ranges-report?marketList=${TRANSLATION_TOOL_REGIONS.EU}`;
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadTransparentPricingReport(user) {
    const url = `${this.reportingUrl}/reporting/po/transparent-pricing-report`;
    const universalBOM = "\uFEFF";
    return axios
      .get(url, getHeadersForCsv(user.token))
      .then((response) => encodeURIComponent(`${universalBOM}${response.data}`))
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadTransparentAccessoriesPricingReport(user) {
    const url = `${this.reportingUrl}/reporting/po/transparent-accessories-pricing-report`;
    const universalBOM = "\uFEFF";
    return axios
      .get(url, getHeadersForCsv(user.token))
      .then((response) => encodeURIComponent(`${universalBOM}${response.data}`))
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
